<template>
  <ErrorBoundary>
    <ElevatedCard class="px-4 py-5 bg-white">
      <div class="card-body text-center">
        <div>
          <div class="flex items-start justify-between gap-2">
            <h6 class="text-left text-[1.125rem]">
              {{
                eventType === 'GIFT_CARD'
                  ? t(
                      'product.show.checkout.corporateGiftRequest.giftcardTitle'
                    )
                  : t('product.show.checkout.corporateGiftRequest.kitTitle')
              }}
            </h6>
            <span
              v-if="eventType === 'BOX'"
              class="bg-lime-200 text-lime-900 text-xs font-semibold px-3 py-1 rounded-full shrink-0"
            >
              {{ t('product.show.checkout.corporateGiftRequest.freeBadge') }}
            </span>
          </div>
          <p class="mt-2 text-left text-sm">
            {{
              eventType === 'GIFT_CARD'
                ? t(
                    'product.show.checkout.corporateGiftRequest.giftcardDescription'
                  )
                : t('product.show.checkout.corporateGiftRequest.kitDescription')
            }}
          </p>
        </div>

        <Button
          variant="outlined"
          class="p-2 py-2.5 w-full mt-4 group flex justify-center"
          data-test-id="corporate-gift-request-button"
          link="https://share-eu1.hsforms.com/1ltkibOaNThaZDN40JuR-yAewif8"
          open-new-tab
          @click="sendCorporateGiftRequestGTMEvent(eventType)"
        >
          <span class="flex justify-center items-center relative gap-1">
            <Gift class=" w-4 h-4" />
            <span>
              {{
                eventType === 'BOX'
                  ? t('product.show.checkout.corporateGiftRequest.contactUsBox')
                  : t('product.show.checkout.corporateGiftRequest.contactUs')
              }}
            </span>
          </span>
        </Button>
      </div>
    </ElevatedCard>
  </ErrorBoundary>
</template>
<script setup lang="ts">
import { Gift } from 'lucide-vue-next'
import { sendCorporateGiftRequestGTMEvent } from '~/composables/useGtmEvents'
const { eventType } = defineProps<{
  eventType: 'GIFT_CARD' | 'BOX'
}>()
const { t } = useI18n()
</script>
